import script from "./scopeServices.vue?vue&type=script&setup=true&lang=js"
export * from "./scopeServices.vue?vue&type=script&setup=true&lang=js"

import "./scopeServices.vue?vue&type=style&index=0&id=badb9dfc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_e6558ed2e51dee85cd0a9e429c286fa8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-badb9dfc"]])

export default __exports__